import React from "react";
import { sendEvent } from "../../../utils/analytics/ga4";
import { AccessibilityButton } from '@skillz/accessibility';

const Button = ({ report, children, dropStyle, onClick, className, isBtn = true, accessibilityDescription }) => {

    const handleClick = (event) => {
        if (report) {
            sendEvent(report.eventName, report.eventProps)
        }
        onClick && onClick(event);
    }

    return isBtn ?
        <AccessibilityButton
            accessibilityDescription={accessibilityDescription}
            className={className}
            style={dropStyle}
            onClick={handleClick}>
            {children}
        </AccessibilityButton> :
        <div className={className} style={dropStyle}>{children}</div>
}

export default Button;